import { render, staticRenderFns } from "./PatientSamples.vue?vue&type=template&id=90b70418&scoped=true"
import script from "./PatientSamples.vue?vue&type=script&lang=js"
export * from "./PatientSamples.vue?vue&type=script&lang=js"
import style0 from "./PatientSamples.vue?vue&type=style&index=0&id=90b70418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b70418",
  null
  
)

export default component.exports